import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

type SupportedLanguage = "en" | "tr";

const languageLoaders: Record<
  SupportedLanguage,
  () => Promise<{ default: Record<string, unknown> }>
> = {
  en: () => import("../locales/en.json"),
  tr: () => import("../locales/tr.json"),
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "tr"],
    load: "languageOnly",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export async function loadLanguageResources(language: string) {
  const supportedLanguage: SupportedLanguage = language === "tr" ? "tr" : "en";
  if (!i18n.hasResourceBundle(supportedLanguage, "translation")) {
    const module = await languageLoaders[supportedLanguage]();
    i18n.addResourceBundle(
      supportedLanguage,
      "translation",
      module.default,
      true,
      true
    );
  }
  await i18n.changeLanguage(supportedLanguage);
}

export default i18n;
